"use client";

import { useEffect, useState, useRef } from "react";

import { useSelector, useDispatch } from "react-redux";

import PropTypes from "prop-types";

import Container from "components/grid/container";
import SaveTheSearchButton from "components/save-the-search-button";
import TriggerAlert from "@/src/components/listing-search/trigger-alert";

import { numberFormatter } from "helpers/number-formatter";
import { GTMPushEvent } from "@/src/helpers/google-tag-manager";

import { toggleSaveSearchTrigger } from "@/src/store/listingSearch";

import styles from "./styles.module.css";

const StickyHeader = ({ name, urlPath, totalListingLength, seoTitle }) => {
  const showTimer = useRef(null);
  const hideTimer = useRef(null);

  const dispatch = useDispatch();

  const showPopup = useSelector((state) => state.listingSearch.saveSearchTrigger);

  const [stickyIsVisible, setStickyIsVisible] = useState(false);

  useEffect(() => {
    if (!showPopup) {
      cleanupTimers();
    }
  }, [showPopup]);

  useEffect(() => {
    checkScrollVisibility(setStickyIsVisible);
    const handleScroll = () => checkScrollVisibility(setStickyIsVisible);

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const checkScrollVisibility = (setVisible, threshold = 205) => {
    const scrollY = window.scrollY;
    setVisible(scrollY > threshold);
  };

  useEffect(() => {
    const hasSeenAlert = localStorage.getItem("trigger_alert_seen:save-search");

    if (hasSeenAlert !== "true" && totalListingLength > 0) {
      triggerPopupSequence();

      return () => {
        cleanupTimers();
      };
    }
  }, []);

  const pushGTMEvent = () => {
    const eventData = {
      event: "ga4_event",
      event_name: "view_widget",
      event_parameters: {
        widget: "aramayi-kaydet-onboarding",
      },
    };
    GTMPushEvent(eventData);
  };

  const triggerPopupSequence = () => {
    showTimer.current = setTimeout(() => {
      dispatch(toggleSaveSearchTrigger(true));
      pushGTMEvent();
      localStorage.setItem("trigger_alert_seen:save-search", "true");

      hideTimer.current = setTimeout(() => {
        dispatch(toggleSaveSearchTrigger(false));
      }, 7000);
    }, 15000);
  };

  const cleanupTimers = () => {
    clearTimeout(showTimer.current);
    clearTimeout(hideTimer.current);
  };

  const handleClosePopup = () => {
    dispatch(toggleSaveSearchTrigger(false));
    clearTimeout(showTimer.current);
    clearTimeout(hideTimer.current);
  };

  return (
    stickyIsVisible && (
      <div className={styles.stickyComponent}>
        <div className={styles.wrapper}>
          <Container>
            <div className={styles.content}>
              <div className={styles.mainTitle}>
                <p className={styles.title}>{seoTitle?.h1}</p>
                {totalListingLength > 0 ? (
                  <span className={styles.adsCount}>
                    araması için <strong className={styles.strong}>{numberFormatter(totalListingLength)}</strong> ilan
                    bulundu
                  </span>
                ) : (
                  <span className={styles.adsCount}>araması için uygun ilan bulunamadı</span>
                )}
              </div>
              <div className={styles.boardingWrapper}>
                <SaveTheSearchButton name={name} urlPath={urlPath} FlashingDot={showPopup} isListingSticky={true} />
                {showPopup && <TriggerAlert onClose={handleClosePopup} />}
              </div>
            </div>
          </Container>
        </div>
      </div>
    )
  );
};

StickyHeader.propTypes = {
  name: PropTypes.string,
  urlPath: PropTypes.string,
  totalListingLength: PropTypes.number,
  seoTitle: PropTypes.object,
};

export default StickyHeader;
